var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoveCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5713 27.1354C30.5742 32.1964 25.5593 35.5482 19.6883 35.5482C14.627 35.5482 8.99866 32.302 7.00149 27.2409L6.93144 27.0674C6.29777 25.4799 6.40044 23.5368 6.40044 21.7201L8.43599 3.75025L14.1135 9.34547C15.736 8.65281 17.5204 8.2692 19.393 8.2692H19.9834C21.8561 8.2692 23.6405 8.65281 25.2629 9.34547L31.496 3.19464L33.5624 22.0002C33.5624 23.8169 33.2136 25.5514 32.5794 27.1388",
    fill: "#F4AA41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6882 35.5482C25.5775 35.7383 30.9875 32.2152 32.9846 27.1541L33.0462 27.0259C33.6798 25.4384 34.1331 23.1974 34.1331 21.3808L31.496 3.19464",
    fill: "#E27022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2676 17.3909C12.5099 15.382 9.40998 15.2535 9.6042 18.1801C9.63003 18.5685 9.77248 18.9422 9.98836 19.2663L13.1734 23.1128L16.3005 19.3599C16.6476 18.9429 16.853 18.4149 16.8425 17.8714C16.7908 15.2647 13.8174 15.4547 13.1727 17.3901",
    fill: "#D22F27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1033 27.0214C14.1033 27.0214 18.4333 29.3308 19.8767 25.2894C21.32 29.3308 25.8749 26.9937 25.8749 26.9937C25.8749 26.9937 24.3796 29.4258 23.9389 29.8991C21.7088 32.2939 18.7203 32.1495 16.3493 29.9639C15.8301 29.4853 14.1033 27.0214 14.1033 27.0214Z",
    fill: "#EA5A47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0025 17.3909C26.2447 15.382 23.1448 15.2535 23.3391 18.1801C23.3649 18.5685 23.5073 18.9422 23.7232 19.2663L26.9083 23.1128L30.0354 19.3599C30.3825 18.9429 30.5878 18.4149 30.5774 17.8714C30.5257 15.2647 27.5523 15.4547 26.9076 17.3901",
    fill: "#D22F27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4548 30.0328L29.1941 27.2657",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.113 32.9793L26.917 30.0926",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38291 26.6906C6.76274 25.1554 6.42163 23.478 6.42163 21.7212L8.4423 3.5351L14.537 9.48326C16.1242 8.81343 17.8691 8.44243 19.7004 8.44243H20.2777C22.1089 8.44243 23.8539 8.81343 25.441 9.48326L31.5357 3.5351L33.5564 21.7212C33.5564 23.478 33.2153 25.1554 32.5951 26.6906",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 32.9917C14.7131 34.2648 17.1211 35 19.7006 35H20.2779C22.8574 35 25.2654 34.2648 27.303 32.9917",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 30.0926L10.7517 27.2059",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86499 32.9793L13.061 30.0926",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2679 17.4427C12.5101 15.4338 9.41022 15.3053 9.60444 18.2319C9.63028 18.6203 9.77272 18.9941 9.98861 19.3181L13.1737 23.1646L16.3008 19.4117C16.6479 18.9947 16.8532 18.4667 16.8428 17.9232C16.7911 15.3166 13.8177 15.5065 13.1729 17.4419",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0025 17.4427C26.2447 15.4338 23.1448 15.3053 23.3391 18.2319C23.3649 18.6203 23.5073 18.9941 23.7232 19.3181L26.9083 23.1646L30.0354 19.4117C30.3825 18.9947 30.5878 18.4667 30.5774 17.9232C30.5257 15.3166 27.5523 15.5065 26.9076 17.4419",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5764 25.2587H22.1986",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1099 26.9921C14.1099 26.9921 18.4432 29.3032 19.8876 25.2587C21.3321 29.3032 25.8904 26.9643 25.8904 26.9643C25.8904 26.9643 24.394 29.3983 23.9529 29.872C21.7211 32.2686 18.7304 32.1241 16.3576 29.9368C15.838 29.4578 14.1099 26.9921 14.1099 26.9921Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveCat);
export default __webpack_public_path__ + "static/media/loveCat.f79b8b2ef66dc922d9e46c230ac753fb.svg";
export { ForwardRef as ReactComponent };